import React, { useState, useEffect } from 'react'
import viewportContext from '../../contexts/viewport'
import getBreakpoint from '../../utilities/get-breakpoint'

const ViewportProvider = ({ children }) => {
    const [ width, setWidth ] = useState(window.innerWidth)
    const [ height, setHeight ] = useState(window.innerHeight)
    const [ breakpoint, setBreakpoint ] = useState(getBreakpoint(window.innerWidth))

    const handleWindowResize = () => {
        setWidth(window.innerWidth)
        setHeight(window.innerHeight)
        setBreakpoint(getBreakpoint(window.innerWidth))
    }

    useEffect(() => {
        window.addEventListener('resize', handleWindowResize)
        return () => window.removeEventListener('resize', handleWindowResize)
    }, [])

    return (
        <viewportContext.Provider value={{ width, height, breakpoint }}>
            {children}
        </viewportContext.Provider>
    )

}

export default ViewportProvider